import { render, staticRenderFns } from "./ModalUpdatePassword.vue?vue&type=template&id=60591252&scoped=true"
import script from "./ModalUpdatePassword.vue?vue&type=script&lang=js"
export * from "./ModalUpdatePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60591252",
  null
  
)

export default component.exports